<template>
  <div id="main">
    <div class="container">
      <div class="row pt-2">
        <div class="col-sm-12 content">
          <div class="header_template">
            <div class="profile_user">
              <h3>{{ ho_ten }}</h3>
              <ul>
                <li>Ngày sinh dương lịch: {{ dob_solar }}</li>
                <li>Ngày sinh âm lịch: {{ dob_lunar }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"/>
      <div class="row">
        <div>
          <div class="progress">
            <div
              class="progress-bar"
              role="progressbar"
              aria-valuenow="10"
              aria-valuemin="0"
              aria-valuemax="100"
              style="width:10%"/>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 content">
          <p class="text-description">Bạn {{ ho_ten }} thân mến! Lá số chính là đề cương, là gợi ý của tạo hóa dành riêng
          cho mỗi con người. Nếu chúng ta biết được ý đồ thiên tạo thì có thể thay đổi nhận thức, hành vi và môi
          trường địa lý cho phù hợp, nhằm tìm cát tránh hung, làm chủ cuộc đời. Nắm trước được vận mệnh sẽ tận dụng
          được thời cơ, giảm tránh được tai họa. Khi vận tốt đến, sẽ dốc toàn lực để đạt được đỉnh cao của vận. Nếu
          thành công, cũng không tỏ ra chủ quan, ngạo mạn, dẫn đến sai lầm. Khi vận xấu đến, sẽ nằm im ẩn dật để giảm
          thiểu tổn thất. Nếu rủi ro, thất bại, cũng không bi quan yếm thế, vui vẻ đón đợi, chấp nhận vượt qua để chờ
          vận mới. Đó là lý do những bậc chân tu, đại phu, hiền triết luôn mỉm cười và ung dung vượt qua hoạn nạn.
          Bằng cách phân tích năm tháng ngày giờ sinh, chúng tôi đã kết hợp cổ học tinh hoa, trí tuệ nhân tạo và các
          thuật toán máy tính để phân tích lá số, đồng thời dự báo và gợi ý cho bạn những việc nên làm, nhằm mang lại
          sự bình an, hỉ lạc, hưng vượng lâu dài.</p>
          <div
            v-if="tong_quan.length > 0">
            <div
              v-for="item in tong_quan">
              <ul>
                <li>{{ item }}</li>
              </ul>

              <div>
                <div class="progress">
                  <div
                    class="progress-bar"
                    role="progressbar"
                    aria-valuenow="10"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style="width:10%"/>
                </div>
              </div>
            </div>
          </div>

          <div 
            v-for="item in luan_giai" 
            v-if="luan_giai.length > 0">
            <h3>{{ item.title }}</h3>

            <h5>Nội dung:</h5>

            <ul
              v-for="value in item.data.noi_dung"
              v-if="item.data.noi_dung">
              <li>{{ value }}</li>
            </ul>

            <h5>Khuyến nghị:</h5>
            <ul
              v-for="khuyen in item.data.khuyen_nghi"
              v-if="item.data.khuyen_nghi">
              <li>{{ khuyen }}</li>
            </ul>
            <div>
              <div class="progress">
                <div
                  class="progress-bar"
                  role="progressbar"
                  aria-valuenow="10"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width:10%"/>
              </div>
            </div>
          </div>

          <div v-if="van_han">
            <h3>VẬN HẠN 2020 - CANH TÝ:</h3>
            <ul>
              <h5>Tóm tắt:</h5>

              <li
                v-for="common in van_han.common"
                style="margin-left: 5px"> - {{ common }}</li>

              <h5>Chi tiết:</h5>

              <li v-for="m in van_han.months">
                <b> - Tháng: {{ m.lunar_mon }}</b>
                <ul
                  v-for="content in m.content"
                  style="margin-left: 10px">
                  <td>{{ content }}</td>
                </ul>
              </li>

            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {errorToaster} from '../../services/ErrorHandler'
  import ApiConfig from '../../communicate/ApiConfig'
  import rf from '../../communicate/RequestFactory'
  import "@/assets/fonts/UTM_Ambrosia.ttf";
  import "@/assets/fonts/Roboto-Light.ttf";

  export default {
    name: "LasoContent",
    data () {
      return {
        id: this.$route.params.id,
        base_url: ApiConfig.base_url,
        ho_ten: '',
        dob_solar: '',
        dob_lunar: '',
        luan_giai: [],
        tong_quan: [],
        van_han: {}
      }
    },

    mounted () {
      this.getLasoContent(this.id);
    },
    methods: {
      getLasoContent (id) {
        rf.getRequest("ServiceRequest").getLasoNative(id).then((res) => {
          if (res.status === 200) {
            this.service = res.data;
            this.ho_ten = this.service.ho_ten;
            this.dob_solar = this.service.dob_solar;
            this.dob_lunar = this.service.dob_lunar;
            this.luan_giai = this.service.luan_giai;
            this.tong_quan = this.service.tong_quan;
            this.van_han = this.service.van_han;
          } else if (res.status === 401 || res.status === 403) {
            this.$router.push({path: `/login`});
          } else {
            errorToaster("Cố vấn phong thủy", res.message);
          }
        }).catch(err => {
          errorToaster("Cố vấn phong thủy", "Xảy ra lỗi kết nối");
        })
      }
    }
  }
</script>

<style scoped>
  #main {
    width: 100%;
    height: auto;
    font-family: r-light;
  }

  .header_template {
    width: 100%;
    height: 85px;
  }

  .profile_user {
    position: absolute;

  }

  .profile_user h3 {
    font-size: 30px;
    font-family: ambrosia;
    margin-top: 10px;
    margin-bottom: 2px;
    color: #000000;
  }

  .profile_user ul {
    list-style-type: none;
    padding-left: 0;
  }

  .profile_user ul li {
    font-family: r-light;
    font-style: normal;
    font-weight: normal;
    font-size: 8px;
    line-height: 11px;
    color: #000000;
  }

  .logo_phongthuy {
    position: absolute;
    right: 0;
    display: flex;
    top: 0;
  }

  .logo_phongthuy .logo img {
    margin-top: 10px;
  }

  .logo_phongthuy .navbar-brand img {
    float: left;
    margin-right: 4px;
    clear: both;
    width: 32px;
    height: 32px;
  }

  .logo_phongthuy .navbar-brand span {
    font-size: 9px;
    font-family: r-light;
    color: #000;
    position: relative;
    top: -7px;
  }


  .progress {
    height: 2px;
    margin-bottom: 6px;
  }

  .progress-bar {
    height: 2px;
    background-color: #008544
  }

  .content .text-description {
    font-family: r-light;
    font-style: normal;
    font-weight: normal;
    font-size: 11px;
    line-height: 13px;
    text-align: justify;
  }

  .content h3 {
    font-family: ambrosia;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    text-transform: capitalize;
    line-height: 26px;
    color: #ED1C25;
    margin-top: 0;
  }

  .content h5 {
    font-family: r-light;
    font-style: normal;
    font-weight: bold;
    font-size: 11px;
    line-height: 13px;
    text-align: justify;
    text-decoration-line: underline;
    color: #000000;
  }

  .content p {
    font-family: r-light;
    font-style: normal;
    font-size: 10px;
    line-height: 13px;
    text-align: justify;
    color: #000000;

  }

  .content ul {
    list-style-type: none;
    padding-left: 0;
  }

  .content ul li {
    font-family: r-light;
    font-style: normal;
    font-weight: normal;
    font-size: 11px;
    line-height: 13px;
    color: #000000;
  }

  @media screen and (max-width: 320px) {
    .logo_phongthuy .navbar-brand {
      font-size: 11px;
    }

    .logo_phongthuy .navbar-brand img {
      width: 26px;
      height: 26px;
    }

    .logo_phongthuy .navbar-brand span {
      font-size: 7px;
    }
  }

  @media screen and (max-width: 360px) and (min-width: 321px) {
    .logo_phongthuy .navbar-brand span {
      font-size: 7px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/history/LasoContent.vue